// AI 写作的前置条件
export interface IAIWritingPrompt {
  title: string
  tone: 'bullish' | 'bearish' | 'neutral'
}

// AI-Writing写作步骤
export enum IWritingStep {
  promopt = 0,
  knowledgeBase = 1,
  brainstorming = 2,
  generating = 3,
}

export interface IDataBase {
  id: string
  title: string
  content: string
  source: string
  edited: boolean
}

// 大纲写文思路（写问的问题）
export interface IOutlineConcept {
  id: string
  isNew?: boolean // 是否是新增的
  question: string // 最终的问题（可能被用户修改过），用于标注数据（使用的）
  answerStatus?: boolean // 选取数据是否成功
  answer?: string //  取数内容
  answerLoading?: boolean // 是否正在取数
  answerLoaded?: boolean // 是否取数结束
  rqInfo?: RQInfo
}

export interface IAIOutline {
  id: string
  title: string // 最终的大纲标题（可能被用户修改过），用于标注数据（使用的）
  aiModelTitle: string // ai模型生成的标题，不可修改，用于标注数据来源（最初的）
  questionPrompt: string // 大纲获取写文思路时返回的Prompt
  aiModelQuestion: string // 大纲获取写文思路时返回内容
  concepts: IOutlineConcept[]
  isNew?: boolean // 是否是新增的
  rqInfo?: RQInfo
}

// 请求状态
export interface IAIOutlineRequestStatus {
  begin?: boolean // 是否开始
  outlineLoading?: boolean // 大纲加载中
  outlineLoaded?: boolean // 大纲加载完毕

  titleLoading?: boolean // 大纲标题加载中
  titleLoadingPosition?: number //  当前正在加载的大纲标题的下标
  titleLoaded?: boolean // 大纲标题加载完毕

  conceptLoading?: boolean // 大纲写文思路加载中
  // conceptLoadingPosition?: number // 效果和titleLoadingPosition一样
  conceptLoaded?: boolean // 大纲写文思路加载完毕

  referenceLoading?: boolean // 大纲写文问题的取数加载中
  // referenceLoadingPosition?: number // 效果和titleLoadingPosition一样
  referenceLoaded?: boolean
}

export interface RQInfo {
  ask: Function
  close: Function
}

export interface IArticleTextData {
  text: string
  type: TextType
  start: boolean //特殊标签开始标志
  finish: boolean //特殊标签结束标志
  timestamp: string // 时间戳
}

export enum TextType {
  TEXT = 'text',
  TITLE = 'title',
  TEXT2IMG = 'text2img',
  VISUAL = 'visual',
  PROMPT = 'prompt',
}

// 人设信息
export interface ICharacter {
  id: string
  name: string
  avatar: string
  introduce: string // 介绍
  bio: string // 简介
}

// 人设筛选项
export interface ICharacterFilter {
  condition: string
  field: string
  options: string[]
}

// 已经选择的人设筛选项
export interface ISelectedCharacterFilter {
  field: string
  options: string[]
}
